module.exports = __webpack_public_path__ + "img/logo-title.a692c47f.png";